import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';

const FloatingCRMButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show on CRM pages
  const isCRMPage = location.pathname.startsWith('/crm');

  useEffect(() => {
    if (isCRMPage || isDismissed) {
      setIsVisible(false);
      return;
    }

    // Show after scrolling down 300px
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isCRMPage, isDismissed]);

  const handleClick = () => {
    navigate('/crm/pricing');
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsDismissed(true);
    // Reset after 5 minutes
    setTimeout(() => setIsDismissed(false), 5 * 60 * 1000);
  };

  if (!isVisible || isCRMPage) return null;

  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 transform transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      <div className="relative group">
        {/* Dismiss button */}
        <button
          onClick={handleDismiss}
          className="absolute -top-2 -right-2 w-6 h-6 bg-slate-800 hover:bg-slate-700 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity border border-slate-600 z-10"
          title="Dismiss"
        >
          <X className="w-3 h-3 text-slate-400" />
        </button>

        {/* Main Button */}
        <button
          onClick={handleClick}
          className="relative flex items-center gap-3 px-5 py-3 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-full shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 transition-all hover:scale-105"
          data-testid="floating-crm-btn"
        >
          {/* Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 animate-ping opacity-20" />
          
          <Sparkles className="w-5 h-5" />
          <span>Try CRM Free</span>
          
          {/* NEW badge */}
          <span className="absolute -top-2 -left-1 px-2 py-0.5 text-[10px] font-bold bg-green-500 text-white rounded-full">
            NEW
          </span>
        </button>
      </div>
    </div>
  );
};

export default FloatingCRMButton;
